<div class="process-calculation-container" [class.pc--cabinet]="inCabinet || embedded">
  <!-- Кабинет: заголовок раздела, меню расчёта — слева -->
  <header class="pc-head" *ngIf="inCabinet && !embedded">
    <h1>{{ sectionTitle }}</h1>
    <p *ngIf="calculation">{{ t('calcSections.accountNumber', 'Учётный номер') }}: <strong>№ {{ calculation.id }}</strong></p>
  </header>

  <div class="header" *ngIf="!inCabinet && !embedded">
    <button type="button" class="btn-back" (click)="onBack()">← {{ backText }}</button>
    <h1>{{ pageTitle }}</h1>
  </div>

  <div *ngIf="loading && !calculation" class="loading-message">{{ loadingText }}</div>
  <div *ngIf="error" class="error-message">{{ error }}</div>

  <ng-container *ngIf="calculation">
    <div class="tabs" *ngIf="!inCabinet && !embedded">
      <button type="button" class="tab-button" [class.active]="activeTab === 'calculation'" (click)="switchTab('calculation')">
        {{ tabCalculationText }}
      </button>
      <button type="button" class="tab-button" [class.active]="activeTab === 'supply'" (click)="switchTab('supply')">
        {{ tabSupplyText }}
      </button>
      <button type="button" class="tab-button" [class.active]="activeTab === 'transportation'" (click)="switchTab('transportation')">
        {{ tabTransportationText }}
      </button>
    </div>

    <div class="tab-content" *ngIf="activeTab === 'calculation'">
      <app-view-calculation-details
        [calculation]="calculation"
        [loading]="false"
        [error]="null"
        [showBackButton]="false"
      ></app-view-calculation-details>
    </div>

    <div class="tab-content" *ngIf="activeTab === 'supply'">
      <ng-container *ngIf="!isCargoOwner()">
        <p class="hint">{{ supplyOwnerOnlyHintText }}</p>
      </ng-container>

      <ng-container *ngIf="isCargoOwner()">
        <div *ngIf="calculation.supplierId">
          <div class="supplier-connected">
            <p>✓ {{ supplierConnectedText }} <strong>{{ calculation.supplierCompanyName || ('#' + calculation.supplierId) }}</strong></p>
          </div>

          <app-supplier-document [calculationId]="calculationId" [readonlyMode]="true"></app-supplier-document>
          <app-contract-upload [calculationId]="calculationId" role="OWNER"></app-contract-upload>
        </div>

        <div *ngIf="!calculation.supplierId" class="supplier-invite">
          <p class="hint">{{ supplierInviteHintText }}</p>

          <button
            type="button"
            class="btn btn-primary"
            *ngIf="!supplierInviteLink"
            [disabled]="generatingSupplierInvite"
            (click)="generateSupplierInvite()"
          >
            {{ generatingSupplierInvite ? generatingInviteText : invitesSupplierButtonText }}
          </button>

          <div *ngIf="supplierInviteError" class="error-message">{{ supplierInviteError }}</div>

          <div *ngIf="supplierInviteLink" class="invite-link-box">
            <input type="text" readonly [value]="supplierInviteLink" (click)="$any($event.target).select()" />
            <button type="button" class="btn btn-secondary" (click)="copySupplierInviteLink()">
              {{ supplierInviteCopied ? copiedText : copyText }}
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="tab-content" *ngIf="activeTab === 'transportation'">
      <ng-container *ngIf="!isCargoOwner(); else transportationContent">
        <p class="hint">{{ needCompanyDataHintText }}</p>
      </ng-container>
      <ng-template #transportationContent>
        <!-- Сделка уже заключена по одной из заявок — остальные заявки-сёстры больше не
             показываем, они не нужны (грузовладелец при желании удалит их сам). -->
        <app-view-deal
          *ngIf="dealRequest as dr; else requestsList"
          [embeddedDealId]="dr.dealId!"
        ></app-view-deal>

        <ng-template #requestsList>
          <div class="requests-list" *ngIf="cargoRequests.length > 0">
            <div class="request-card" *ngFor="let r of cargoRequests">
              <button type="button" class="request-card__header" (click)="toggleRequestExpanded(r.id)">
                <span class="request-card__title">
                  {{ requestFallbackPrefixText }}{{ r.id }} — {{ requestSummary(r) }}
                </span>
                <span class="request-card__meta">
                  <span *ngIf="r.bidsCount">{{ r.bidsCount }} {{ bidsCountSuffixText }}</span>
                  <span class="request-card__toggle">
                    {{ isRequestExpanded(r.id) ? ('▲ ' + collapseRequestText) : ('▼ ' + expandRequestText) }}
                  </span>
                </span>
              </button>

              <div class="request-card__body" *ngIf="isRequestExpanded(r.id)">
                <app-view-request [embeddedRequestId]="r.id"></app-view-request>
              </div>
            </div>
          </div>

          <p class="hint" *ngIf="cargoRequests.length > 0">{{ addRequestHintText }}</p>

          <button
            type="button"
            class="btn btn-secondary"
            *ngIf="cargoRequests.length > 0 && !showAddRequestForm"
            (click)="showAddRequestForm = true"
          >
            {{ addRequestButtonText }}
          </button>

          <app-create-request
            *ngIf="cargoRequests.length === 0 || showAddRequestForm"
            [customsCalculationId]="calculationId"
            (requestCreated)="onRequestCreated()"
          ></app-create-request>
        </ng-template>
      </ng-template>
    </div>
  </ng-container>

  <app-upgrade-to-cargo-owner-modal
    *ngIf="showUpgradeModal"
    (upgraded)="onUpgraded()"
    (cancel)="onUpgradeCancel()"
  ></app-upgrade-to-cargo-owner-modal>
</div>
